module.exports = __webpack_public_path__ + "assets/img/BETWAY.4d703254.png";